<script lang="ts">
	import heroPoster from "@assets/images/hero-thumb.webp?w=880&format=webp&imagetools";
	import Layout from "@components/layout/Layout.svelte";
	import ArticlesSection from "@components/sections/ArticlesSection.svelte";
	import CaseStudiesSection from "@components/sections/CaseStudiesSection.svelte";
	import HeroSection from "@components/sections/HeroSection.svelte";
	import NewsletterSection from "@components/sections/NewsletterSection.svelte";
	import PartnersSection from "@components/sections/PartnersSection.svelte";
	import ProductsSection from "@components/sections/ProductsSection.svelte";
	import ReviewSection from "@components/sections/ReviewSection.svelte";
	import ServicesSection from "@components/sections/ServicesSection.svelte";
	import type { HomepageProps } from "./HomepageProps.js";

	const { articles, caseStudies, partners, products, reviews, mainCaseStudy }: HomepageProps = $props();
</script>

<Layout ogImage={heroPoster}>
	<HeroSection />
	<ReviewSection {reviews} />
	<ServicesSection />
	<CaseStudiesSection {caseStudies} {mainCaseStudy} />
	<PartnersSection {partners} />
	<ProductsSection {products} />
	<NewsletterSection />
	<ArticlesSection {articles} />
</Layout>
